jQuery(document).ready(function($) {

    console.log("doc ready");

    var mediacodeQSP = getParameterByName('mediacode');

    var mediacodeCookie = Cookies.get('mediacode');

    var emailQSP = getParameterByName('email');

    var basVendorQSP = getParameterByName('bas_vendor');

    var basVendorCookie = Cookies.get('bas_vendor');

    var basphoneQSP = getParameterByName('bas_phone');

    var sfcidQSP = getParameterByName('sfcid');

    var gclidQSP = getParameterByName('gclid');

    var msclkidQSP = getParameterByName('msclkid');

    var utmsourceQSP = getParameterByName('utm_source');

    var utmmediumQSP = getParameterByName('utm_medium');

    var utmcampaignQSP = getParameterByName('utm_campaign');

    var utmtermQSP = getParameterByName('utm_term');

    var utmcontentQSP = getParameterByName('utm_content');

    var campaignidQSP = getParameterByName('campaignid');

    var adgroupidQSP = getParameterByName('adgroupid');

    var keywordQSP = getParameterByName('keyword');

    var matchtypeQSP = getParameterByName('matchtype');

    var networkQSP = getParameterByName('network');

    var deviceQSP = getParameterByName('device');

    var extensionidQSP = getParameterByName('extensionid');

    var basphoneCookie = Cookies.get('bas_phone');

    var sfcidCookie = Cookies.get('sfcid');

    var gclidCookie = Cookies.get('gclid');

    var msclkidCookie = Cookies.get('msclkid');

    var utmsourceCookie = Cookies.get('utm_source');

    var utmmediumCookie = Cookies.get('utm_medium');

    var utmcampaignCookie = Cookies.get('utm_campaign');

    var utmtermCookie = Cookies.get('utm_term');

    var utmcontentCookie = Cookies.get('utm_content');

    var campaignidCookie = Cookies.get('campaignid');

    var adgroupidCookie = Cookies.get('adgroupid');

    var keywordCookie = Cookies.get('keyword');

    var matchtypeCookie = Cookies.get('matchtype');

    var networkCookie = Cookies.get('network');

    var deviceCookie = Cookies.get('device');

    var extensionidCookie = Cookies.get('extensionid');

    if(jQuery('.mediacode').length > 0){
       if(mediacodeQSP){
           jQuery('li.mediacode').find('input').attr('value', mediacodeQSP);
        }
        else{
           jQuery('li.mediacode').find('input').attr('value', mediacodeCookie);
        }
    }
    if(jQuery('.gclid').length > 0){

        if(gclidQSP){
           jQuery('li.gclid').find('input').attr('value', gclidQSP);
        }else{
           jQuery('li.gclid').find('input').attr('value', gclidCookie);
        }
    }
    if(jQuery('.bas_vendor').length > 0){

        if(basVendorQSP){
           jQuery('li.bas_vendor').find('input').attr('value', basVendorQSP);
        }else{
           jQuery('li.bas_vendor').find('input').attr('value', basVendorCookie); 
        }
    }
    if(jQuery('.bas_phone').length > 0){

        if(basphoneQSP){
           jQuery('li.bas_phone').find('input').attr('value', basphoneQSP);
        }else{
           jQuery('li.bas_phone').find('input').attr('value', basphoneCookie); 
        }
    }
    if(jQuery('.sfcid').length > 0){

        if(sfcidQSP){
           jQuery('li.sfcid').find('input').attr('value', sfcidQSP);
        }else{
           jQuery('li.sfcid').find('input').attr('value', sfcidCookie); 
        }
    }
    if(jQuery('.msclkid').length > 0){

        if(msclkidQSP){
           jQuery('li.msclkid').find('input').attr('value', msclkidQSP);
        }else{
           jQuery('li.msclkid').find('input').attr('value', msclkidCookie); 
        }
    }
    if(jQuery('.utm_source').length > 0){

        if(utmsourceQSP){
           jQuery('li.utm_source').find('input').attr('value', utmsourceQSP);
        }else{
           jQuery('li.utm_source').find('input').attr('value', utmsourceCookie); 
        }
    }
    if(jQuery('.utm_medium').length > 0){

        if(utmmediumQSP){
           jQuery('li.utm_medium').find('input').attr('value', utmmediumQSP);
        }else{
           jQuery('li.utm_medium').find('input').attr('value', utmmediumCookie); 
        }
    }
    if(jQuery('.utm_campaign').length > 0){

        if(utmcampaignQSP){
           jQuery('li.utm_campaign').find('input').attr('value', utmcampaignQSP);
        }else{
           jQuery('li.utm_campaign').find('input').attr('value', utmcampaignCookie); 
        }
    }
    if(jQuery('.utm_term').length > 0){

        if(utmtermQSP){
           jQuery('li.utm_term').find('input').attr('value', utmtermQSP);
        }else{
           jQuery('li.utm_term').find('input').attr('value', utmtermCookie); 
        }
    }
    if(jQuery('.utm_content').length > 0){

        if(utmcontentQSP){
           jQuery('li.utm_content').find('input').attr('value', utmcontentQSP);
        }else{
           jQuery('li.utm_content').find('input').attr('value', utmcontentCookie); 
        }
    }
    if(jQuery('.campaignid').length > 0){

        if(campaignidQSP){
           jQuery('li.campaignid').find('input').attr('value', campaignidQSP);
        }else{
           jQuery('li.campaignid').find('input').attr('value', campaignidCookie); 
        }
    }
    if(jQuery('.adgroupid').length > 0){

        if(adgroupidQSP){
           jQuery('li.adgroupid').find('input').attr('value', adgroupidQSP);
        }else{
           jQuery('li.adgroupid').find('input').attr('value', adgroupidCookie); 
        }
    }
    if(jQuery('.keyword').length > 0){

        if(keywordQSP){
           jQuery('li.keyword').find('input').attr('value', keywordQSP);
        }else{
           jQuery('li.keyword').find('input').attr('value', keywordCookie); 
        }
    }
    if(jQuery('.matchtype').length > 0){

        if(matchtypeQSP){
           jQuery('li.matchtype').find('input').attr('value', matchtypeQSP);
        }else{
           jQuery('li.matchtype').find('input').attr('value', matchtypeCookie); 
        }
    }
    if(jQuery('.network').length > 0){

        if(networkQSP){
           jQuery('li.network').find('input').attr('value', networkQSP);
        }else{
           jQuery('li.network').find('input').attr('value', networkCookie); 
        }
    }
    if(jQuery('.device').length > 0){

        if(deviceQSP){
           jQuery('li.device').find('input').attr('value', deviceQSP);
        }else{
           jQuery('li.device').find('input').attr('value', deviceCookie); 
        }
    }
    if(jQuery('.extensionid').length > 0){

        if(extensionidQSP){
           jQuery('li.extensionid').find('input').attr('value', extensionidQSP);
        }else{
           jQuery('li.extensionid').find('input').attr('value', extensionidCookie); 
        }
    }

    // mobile mailing lists step two - https://iusa2018.infousa.com/lists/mailing-list-mobile-step-2
    if (WordPressPageID == '3757') {

        jQuery('#input_1_11').hide();
        jQuery('#input_1_11 option').removeAttr('selected');
        jQuery('#input_1_11').find('option[value="Mailing Lists"]').attr('selected', true);

        if (emailQSP) {
            jQuery('#input_1_5').attr('readonly', 'readonly');
        }

    }

    // add Foundation 6 Reveal modal open attribute to elements having the modal-w2l-form class
    jQuery('.modal-w2l-form').attr('data-open', 'footer-w2l-modal').click(function(event) {
        event.preventDefault();
    });

    // add Foundation 6 Reveal modal open attribute to elements having the modal-registration-form class
    jQuery('.modalRegistration').attr('data-open', 'footer-registration-modal').click(function(event) {
        event.preventDefault();
    });


   // genie product registration form
   jQuery('.contact-policy-hover').hoverIntent(openContactPolicyTooltip,closeContactPolicyTooltip);

	function openContactPolicyTooltip() { 
		jQuery('.contact-policy-tooltip').fadeIn();
	}

	function closeContactPolicyTooltip() {
		jQuery('.contact-policy-tooltip').fadeOut();
	}

    //Floating Labels Other all forms
    jQuery('.floating-labels-form :input').removeAttr('placeholder');
    jQuery('.floating-labels-form .enable-label input, .floating-labels-form .enable-label textarea').focusin(function(){
        jQuery(this).parent().addClass('has-value');
        jQuery(this).parent().parent().find('label').addClass('active-label-value');
    });
    jQuery('.floating-labels-form .enable-label input, .floating-labels-form .enable-label textarea').blur(function(){
        if(!jQuery(this).val().length > 0) {
            jQuery(this).parent().removeClass('has-value');
            jQuery(this).parent().parent().find('label').removeClass('active-label-value');
        }
    });

    //Floating labels Step Form
    jQuery('.floating-labels-step-form :input').removeAttr('placeholder');
    $(document).on('gform_page_loaded', function(event, form_id, current_page) {
        console.log("Form ID:", form_id, "Current Page:", current_page);
        if (current_page == 2) {
            console.log("Second page is loaded");

            $('.floating-labels-step-form .enable-label input, .floating-labels-step-form .enable-label textarea').on('focusin', function() {
                $(this).parent().addClass('has-value');
                $(this).parent().parent().find('label').addClass('active-label-value');
            });

            $('.floating-labels-step-form .enable-label input, .floating-labels-step-form .enable-label textarea').on('blur', function() {
                if (!$(this).val().length > 0) {
                    $(this).parent().removeClass('has-value');
                    $(this).parent().parent().find('label').removeClass('active-label-value');
                }
            });
        }
    });

    jQuery(window).on('load', function() {
        if ('undefined' !== typeof MktoForms2) {
            // Marketo Forms API function for modifying fields of all Marketo forms on the page with cookie data
            MktoForms2.whenReady(function(form){
                form.setValues({
                    "form_SFCID":sfcidCookie,
                    "form_gclid":gclidCookie,
                    "form_msclkid":msclkidCookie,
                    "form_utm_source":utmsourceCookie,
                    "form_utm_medium":utmmediumCookie,
                    "form_utm_campaign":utmcampaignCookie,
                    "form_utm_term":utmtermCookie,
                    "form_utm_content":utmcontentCookie,
                    "form_campaignid":campaignidCookie,
                    "form_adgroupid":adgroupidCookie,
                    "form_keyword":keywordCookie,
                    "form_matchtype":matchtypeCookie,
                    "form_network":networkCookie,
                    "form_device":deviceCookie,
                    "form_extensionid":extensionidCookie,
                    "form_mediacode":mediacodeCookie,
                    "form_long_url": window.location.href
                });
                form.onSuccess(function(){
                    var vals = form.vals();
                    Cookies.set('userSubmittedEmail', vals['Email'], { domain: cookieDomain, path: '/', secure: true });
                });
            });
        }
    });
});
